var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLoader } from "../../app/useLoader";
export var Result = function (_a) {
    var _b = _a.success, success = _b === void 0 ? true : _b, message = _a.message, children = _a.children;
    var isLoading = useLoader().isLoading;
    isLoading(false);
    return (_jsxs("div", __assign({ className: !success ? "text-rose-600" : "text-green-700" }, { children: [message !== null && message !== void 0 ? message : "Thank you for your purchase!", _jsx("div", { children: children })] })));
};
